import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { BackofficeWhatsappRoutesResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof BackofficeWhatsappRoutesResponseDataSchema>>

export const getBackofficeWhatsappRoutesQuery = () =>
  queryOptions({
    queryKey: ["backofficeWhatsappRoutes"],
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/whatsappRoutes")
      return data.data
    },
  })
